import NewMfaSession from 'client/js/new_mfa_session';
import HostingAwardPrompt from 'client/js/hosting_award_prompt';
import EmailVerificationCodeInput from 'client/js/email_verification/code_input';
import { trackEvent } from 'client/js/util/matomo';
import { BooleanInput, ControlGroup, FormActions, GenericReactForm, StringInput, SubmitButton } from 'client/js/util/form_utils';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReCAPTCHA from "react-google-recaptcha";

class ConditionalCaptcha extends React.Component {
  state = { show: false }

  componentDidMount() {
    if (this.context.serverErrors && this.context.serverErrors.captcha)
      this.setState({ show: true });
  }

  componentDidUpdate(previousProps, previousState) {
    if (this.context.serverErrors && this.context.serverErrors.captcha && !previousState.show)
      this.setState({ show: true });
  }

  change = (value) => {
    this.context.formDispatch('value_changed', null, { name: 'recaptcha_response', value: value });
  }

  render () {
    if(!this.state.show)
      return null;

    return (
      <ControlGroup name="captcha" errors={this.context.serverErrors['captcha']}>
        <div className="signup-captcha-text">
          Bitte zeige uns, dass Du ein Mensch bist:
        </div>
        <ReCAPTCHA
          sitekey={this.props.recaptcha_site_key}
          onChange={this.change}
          />
      </ControlGroup>);
  }
}

ConditionalCaptcha.contextTypes = {
  serverErrors: PropTypes.object,
  formDispatch: PropTypes.func
}

class Login extends React.Component {
  state= {}

  redirectAfterAuthentication = () => {
    if (this.props.return_url)
      return window.location.href = this.props.return_url;

    const hash_url = window.location.hash.replace('#!', '');

    if (hash_url)
      window.location.href = hash_url;
    else
      window.location.href = '/usercp';
  }

  completeMfaAuthentication = () => {
    trackEvent('login', 'mfa_success');
    this.redirectAfterAuthentication();
  }

  dispatch = (action, original_event, data) => {
    if (action == 'form:validation_errors' && data && data.status == 'invalid_resource')
      trackEvent('login', 'failure', data.errors && data.errors.captcha ? 'captcha' : 'credentials');

    if (action != 'form:success')
      return;

    trackEvent('login', 'success');

    if (data.object.device_verification_required) {
      this.setState({
        logged_in: true,
        auth_step: 'email_verification',
        user_email: data.object.email
      });
      return;
    }

    if (data.object.mfa_required) {
      trackEvent('login', 'mfa_required');
      return this.setState({ logged_in: true, auth_step: 'mfa' });
    }

    this.setState({ logged_in: true });
    this.redirectAfterAuthentication();
  }

  renderLogoutReviewPrompt() {
    if (!this.props.from_logout)
      return null;

    return (
      <div className="login-review-prompt">
        <p>Vielen Dank, dass Du lima-city nutzt. Wenn Du mit uns zufrieden bist, freuen wir uns sehr über eine kurze Bewertung.</p>
        <a
          href="https://www.hosttest.de/webhoster/lima-city/bewerten"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kurze Bewertung schreiben
        </a>
      </div>
    );
  }

  render() {
    if (this.state.auth_step == 'email_verification') {
      return (
        <div className="login-form-panel login-form-panel-compact">
          <h1 className="login-title">Sicherheitsprüfung</h1>
          <EmailVerificationCodeInput email={this.state.user_email} inline />
        </div>
      );
    }

    if (this.state.auth_step == 'mfa') {
      return (
        <div className="login-form-panel login-form-panel-compact">
          <h1 className="login-title">Zwei-Faktor-Authentifizierung</h1>
          <NewMfaSession inline return_url={this.props.return_url} onSuccess={this.completeMfaAuthentication} />
        </div>
      );
    }

    return (
      <div className="login-form-panel login-form-panel-compact">
        <h1 className="login-title">Login</h1>

        <p className="lead">Neu bei lima-city? <Link to="/register">Jetzt registrieren</Link>!</p>

        <GenericReactForm namespace="user_session" url="/login" dispatch={this.dispatch}>
          <StringInput required name="username" autoComplete="username" label="Benutzername" labelAction={<a href='/hilfe/ich-habe-meinen-benutzernamen-vergessen'>Benutzername vergessen?</a>} />
          <StringInput required name="password" type="password" autoComplete="current-password" label="Passwort" labelAction={<Link to="/lostpassword">Passwort vergessen?</Link>} />
          <BooleanInput name="remember_me" label="an diesem Computer vier Wochen eingeloggt bleiben" />

          <ConditionalCaptcha recaptcha_site_key={this.props.recaptcha_site_key} />

          <FormActions>
            <SubmitButton text="Login" />
          </FormActions>
        </GenericReactForm>

        <HostingAwardPrompt campaign={this.props.hosting_award_campaign}>
          {this.renderLogoutReviewPrompt()}
        </HostingAwardPrompt>
      </div>
    );
  }
}

Login.propTypes = {
  hosting_award_campaign: PropTypes.object,
  from_logout: PropTypes.bool,
  recaptcha_site_key: PropTypes.string,
  return_url: PropTypes.string
};

export default Login;
